<template>
  <main>
    <section class="fk-welcome">
      <h2 class="fk-welcome-title"><span>{{$t('Index.Welocome')}}</span></h2>
      <p class="fk-welcome-read" v-html="$t('Index.Description')"></p>
      <p class="fk-notice-drivethrough">{{$t('Index.NoticeDriveThrough')}}</p>
     <h2 class="title-lv2">{{$t('Index.SelectLanguage')}}<br>{{$t('Index.SelectLanguageEn')}}</h2>
      <ul class="select-language">
        <li><input type="radio" name="language" id="jp" value="" :checked="getLocale()==='ja'" @change="setLocale('ja')"><label for="jp" class="btn-base btn-sub">{{$t('Language.Ja')}}</label></li>
        <li><input type="radio" name="language" id="en" value="" :checked="getLocale()==='en'" @change="setLocale('en')"><label for="en" class="btn-base btn-sub">{{$t('Language.En')}}</label></li>
      </ul>
      <p><input type="button" :value="$t('Index.OrderStart')" :class="[isMaintenance===true ? 'btn-quit' : 'btn-main', 'btn-base']" :disabled="isMaintenance" @click="execOrderStart()"></p>
      <aside v-if="isLogin===false">
        <div id="fk-auth" class="fk-login" v-if="visibleMailAuth===true">
          <h3 class="title-lv3">{{$t('UserLogin.Heading')}}</h3>
          <p class="read">{{$t('UserLogin.Description')}}</p>
          <div class="mod-form-block">
            <span class="label">{{$t('UserLogin.MailAddress')}}</span>
            <input type="email" name="email" id="email" v-model="model.mailaddress">
            <span class="validation-error" v-if="errors.mailaddress !== null">{{errors.mailaddress}}</span>
          </div>
          <div class="mod-form-block">
            <span class="label">{{$t('UserLogin.Password')}}</span>
            <input type="password" name="password" id="password" v-model="model.password">
            <span class="validation-error" v-if="errors.password !== null">{{errors.password}}</span>
          </div>
          <p class="mod-form-btn"><input type="button" :value="$t('UserLogin.Signin')" :class="[isMaintenance===true ? 'btn-quit' : 'btn-main', 'btn-base']" :disabled="isMaintenance" @click.prevent="execMailAuth()"></p>
        </div>
        <div id="fk-2ph-auth" class="fk-login" v-if="visible2PhaseAuth===true">
          <h3 class="title-lv3">{{$t('UserLogin.Heading')}}</h3>
          <p class="read" v-html="$i18n.t('UserLogin.AuthCodeDescription')"></p>
          <div class="mod-form-block">
            <span class="label">{{$t('UserLogin.AuthCode')}}</span>
            <input type="text" name="authcode" id="authcode" v-model="model.authcode">
            <span class="validation-error" v-if="errors.authcode !== null">{{errors.authcode}}</span>
          </div>
          <p class="mod-form-btn"><input type="button" :value="$t('General.Send')" :class="[isMaintenance===true ? 'btn-quit' : 'btn-main', 'btn-base']" :disabled="isMaintenance" @click.prevent="exec2PhaseAuth()"></p>
        </div>
      </aside>
    </section>
  </main>
</template>

<script>
import {get} from 'lodash'
import CommonMixin from '@/mixins/CommonMixin'
import ValidationMixin from '@/mixins/ValidationMixin'
import DisplayErrorMixin from '@/mixins/DisplayErrorMixin'
import DirectStoreAccessMixin from '@/mixins/DirectStoreAccessMixin'
export default {
  name: 'FKMOIndex',
  mixins: [ CommonMixin, ValidationMixin, DisplayErrorMixin, DirectStoreAccessMixin ],
  data () {
    return {
      isMaintenance: false,
      isLogin: false,
      visibleMailAuth: true,
      visible2PhaseAuth: false,
      // モデル
      model: {
        mailaddress: null,
        password: null,
        authcode: null
      },
      errors: {
        mailaddress: null,
        password: null,
        authcode: null
      }
    }
  },
  computed: {
    getAuthCompletedFromApp () {
      return this.$store.getters.authCompletedFromApp
    }
  },
  watch: {
    'getAuthCompletedFromApp' (res) {
      this.loginCheck()
    }
  },
  methods: {
    mainteCheck: function () {
      const _that = this
      this.callApi('MainteStatus')
        .then(function (res) {
          _that.isMaintenance = res.data.value.is_maintenance
          if (_that.isMaintenance) {
            window.commonAlert({text: _that.$i18n.t('Maintenance.Message'), textOk: _that.$i18n.t('Maintenance.ButtonText')})
          }
        })
    },
    loginCheck: function () {
      if (sessionStorage.getItem('login') !== null) {
        this.visibleMailAuth = false
        this.visible2PhaseAuth = false
        return true
      }
      return false
    },
    getLocale: function () {
      return sessionStorage.getItem('lang')
    },
    setLocale: function (locale) {
      sessionStorage.setItem('lang', locale)
      this.$i18n.locale = locale
    },
    execOrderStart: function () {
      // ご注文を始めるボタンのイベント処理
      this.$router.push({ name: 'StoreSelect' })
    },
    execMailAuth: function () {
      // メール認証処理
      let validate = this.validMailLogin(this.model.mailaddress, this.model.password)
      this.errors = Object.assign(this.errors, validate.errors)
      if (!validate.isValid) {
        return false
      }

      const _that = this

      this.callApi('EmailLogin',
        {
          mail_address: this.model.mailaddress,
          password: this.model.password,
          language: sessionStorage.getItem('lang')
        }
      )
      // this.axios.get('/static/stub/index_mail_login.json')
        .then(function (res) {
          if (res.data.result) {
            if (res.data.value.authority === 2) {
              // 特権ユーザーの場合は二段階認証をスキップする
              _that.visibleMailAuth = false
              _that.visible2PhaseAuth = false

              sessionStorage.setItem('login', JSON.stringify(res.data.value))
              _that.$store.dispatch('setServerTime', res.data.value.server_time)
              _that.$store.dispatch('setUserAuthority', get(res, 'data.value.authority', 1))

              // メールアドレスをハッシュ化して保存する
              const email = _that.CryptoJS.AES.encrypt(_that.model.mailaddress, process.env.VUE_APP_EMAIL_HASHKEY).toString()
              sessionStorage.setItem('email', email)
            } else {
              // 認証に成功したのでフラグを二段階認証に切り替える
              _that.visibleMailAuth = false
              _that.visible2PhaseAuth = true
            }
            // 認証に成功したのでpasswordを空にする
            _that.model.password = null
          } else {
            // 認証に失敗したのでフラグをメールアドレス認証に切り替える
            _that.visibleMailAuth = true
            _that.visible2PhaseAuth = false
            _that.errorFromApi(res.data.errorCode, res.data.error)
          }
        })
        .catch(function (error) {
          // 例外になったのでメールアドレス認証に切り替える
          _that.visibleMailAuth = true
          _that.visible2PhaseAuth = false
          _that.errorFromAxios(error)
        })
    },
    exec2PhaseAuth: function () {
      // 2段階認証
      let validate = this.valid2PhaseLogin(this.model.authcode)
      this.errors = Object.assign(this.errors, validate.errors)
      if (!validate.isValid) {
        return false
      }

      const _that = this

      this.callApi('EmailAuth',
        {
          mail_address: this.model.mailaddress,
          auth_code: this.model.authcode,
          language: sessionStorage.getItem('lang')
        }
      )
      // this.axios.get('/static/stub/index_2phase_login.json')
        .then(function (res) {
          if (res.data.result) {
            // 認証に成功したので認証フォームを全て非表示にする
            _that.visibleMailAuth = false
            _that.visible2PhaseAuth = false
            sessionStorage.setItem('login', JSON.stringify(res.data.value))
            _that.$store.dispatch('setServerTime', res.data.value.server_time)
            _that.$store.dispatch('setUserAuthority', get(res, 'data.value.authority', 1))

            // メールアドレスをハッシュ化して保存する
            const email = _that.CryptoJS.AES.encrypt(_that.model.mailaddress, process.env.VUE_APP_EMAIL_HASHKEY).toString()
            sessionStorage.setItem('email', email)
          } else {
            // 認証に失敗したのでフラグを二段階認証に切り替える
            _that.visibleMailAuth = false
            _that.visible2PhaseAuth = true
            _that.errorFromApi(res.data.errorCode, res.data.error)
          }
        })
        .catch(function (error) {
          // 例外になったのでメールアドレス認証に切り替える
          _that.visibleMailAuth = false
          _that.visible2PhaseAuth = true
          _that.errorFromAxios(error)
        })
    },
    resendRequest: function () {
      // 認証コード再送信要求
      // TODO 要件を確認している途中。２段階認証をするため必用になる認識
      const _that = this

      this.callApi('EmailAuth',
        {
          mail_address: this.model.mailaddress,
          language: sessionStorage.getItem('lang')
        }
      )
      // this.axios.get('/static/stub/index_2phase_login.json')
        .then(function (res) {
          // TODO 認証メールを再送信したら何か表示するべきか
        })
        .catch(function (error) {
          _that.errorFromAxios(error)
        })
    },
    checkMultipleLogin: function () {
      const _that = this
      if (sessionStorage.getItem('login') === null) {
        this.callApi('UserInfo',
          {
            language: sessionStorage.getItem('lang')
          }
        )
          .then((res) => {
            if (res.data.result) {
              // ユーザー情報のObject.keysの個数が1個以上であればログイン済みユーザーとみなす
              if (res.data.value.user_info !== null && res.data.value.user_info !== undefined && Object.keys(res.data.value.user_info).length > 0) {
                // 認証済みユーザーなのでログイン情報を保存し、フラグを切り替える。
                _that.visibleMailAuth = false
                _that.visible2PhaseAuth = false
                sessionStorage.setItem('login', JSON.stringify(res.data.value))
                _that.$store.dispatch('setServerTime', res.data.value.server_time)
                _that.$store.dispatch('setUserAuthority', get(res, 'data.value.authority', 1))
              }
            } else {
              _that.errorFromApi(res.data.errorCode, res.data.error)
            }
          })
          .catch(function (error) {
            _that.errorFromAxios(error)
          })
      }
    },
    checkDebugMode: function () {
      if (this.$route.query.fkmo === '1234') {
        this.$store.dispatch('setIsDebug', true)
      }
    }
  },
  beforeMount () {
    this.mainteCheck()
    this.isLogin = this.loginCheck()
    this.checkMultipleLogin()
    this.checkDebugMode()
    // 店舗ダイレクトアクセス
    if (this.setDirectStoreCode(get(this, '$route.query.store', ''))) {
      if (get(this, '$route.query.lang', 'ja') === 'en') {
        this.setLocale('en')
      } else {
        this.setLocale('ja')
      }
      this.$router.push({ name: 'ReceiveMethod' })
    }
  },
  beforeUpdate () {
    this.restoreScaleRate('default') // 拡大縮小のロックを開放
  },
  destroyed () {
    this.restoreScaleRate('reset') // scaleをリセット
  }
}
</script>

<style scoped>
.validation-error {
  color: #f00;
  display: block;
}
input[type=button] {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Index.vue